//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FeeQuestions',
  data () {
    return {
      showExpand: {
        1: true,
        2: true,
        3: true
      }
    }
  }
}
